import { useEffect } from 'react';
import Colors, { InvertedColors, isColorDark } from '../utils/Colors';
import { camelToKebabCase, getKeys } from '../utils';

const useColorTheme = (backgroundColor: string = Colors.white) => {
  const colorsNames = getKeys(Colors);
  const varNames = colorsNames.map(colorName => `--${camelToKebabCase(colorName)}`);

  useEffect(() => {
    const needsInvert = isColorDark(backgroundColor);
    if (needsInvert) {
      varNames.forEach((varName, index) => {
        const invertedColorValue = InvertedColors[colorsNames[index]];
        document.documentElement.style.setProperty(varName, invertedColorValue);
      });
    } else {
      varNames.forEach((varName, index) => {
        document.documentElement.style.setProperty(varName, Colors[colorsNames[index]]);
      });
    }

    return () => {
      varNames.forEach((varName, index) => {
        document.documentElement.style.setProperty(varName, Colors[colorsNames[index]]);
      });
    };
  }, [backgroundColor, varNames, colorsNames]);
};

export default useColorTheme;
